import { graphql } from "@/gql";

export const mailInvoicePaymentMutation = graphql(`
  mutation MailInvoicePayment($id: ID!) {
    sendInvoicePayment(id: $id) {
      id
    }
  }
`);
